import type { ContentTextProps } from '@/components/molecules/ContentText';
import type { ItemsContainerSectionProps } from '@/components/sections/ItemsContainerSection';

import { INTEGRATION_SIDE_CONFIG_RO } from './integration-side-content';

type IntegrationPageTypes = {
    titleSection: ContentTextProps;
    integrationContent: ItemsContainerSectionProps;
};

export const INTEGRATION_CONFIG_RO: IntegrationPageTypes = {
    titleSection: {
        textConfig: [
            {
                type: 'heading1',
                text: 'Integrare',
                className: 'text-center md:text-left heading-space',
            },
        ],
    },
    integrationContent: {
        containerConfig: {
            flexOptions: {
                preset: 'topAlign',
            },
        },
        items: [
            {
                type: 'integration-side-content-template',
                config: INTEGRATION_SIDE_CONFIG_RO,
            },
            {
                type: 'text-content',
                config: {
                    contentTextConfig: {
                        textConfig: [
                            {
                                type: 'heading3',
                                text: 'Valorifică potențialul PayPo în magazinul tău',
                                className: 'text-center md:text-left mb-8',
                            },
                            {
                                type: 'paragraph',
                                text: 'Integrarea cu sistemul nostru de plăți este simplă și rapidă. Doar doi pași te despart de creșterea ratei de conversie pe site-ul tău.',
                                className: 'text-left mb-8',
                            },
                            {
                                type: 'titleText',
                                size: 'm',
                                text: 'În secțiunea „Materiale pentru dezvoltatori"',
                                className: 'text-left mb-4',
                            },
                            {
                                type: 'paragraph',
                                text: 'Am pregătit pentru tine documentație API completă, gata de utilizare în magazinul tău online. Specialiștii noștri te vor ajuta să implementezi rapid și eficient sistemul de plăți pe platforma ta de cumpărături.',
                                className: 'text-left mb-8',
                            },
                            {
                                type: 'titleText',
                                size: 'm',
                                text: 'În secțiunea „Materiale de marketing”',
                                className: 'text-left mb-4',
                            },
                            {
                                type: 'paragraph',
                                text: 'Am inclus materiale informative care îți vor fi utile după etapa de integrare, pentru a informa clienții despre posibilitatea utilizării PayPo în magazinul tău. Materialele sunt optimizate pentru afișare atât pe desktop, cât și pe dispozitive mobile.',
                                className: 'text-left',
                            },
                        ],
                    },
                },
            },
        ],
    },
};

export const INTEGRATION_COPY_MESSAGE_CONFIG_RO = {
    success: {
        title: 'Finalizare',
        message: 'Codul a fost copiat pe dispozitivul tău.',
        variant: 'success',
        duration: 5000,
        hasCloseIcon: true,
    },
    error: {
        title: 'A apărut o eroare',
        message: 'Nu s-a putut copia codul.',
        variant: 'error',
        duration: 5000,
        hasCloseIcon: true,
    },
};

export const INTEGRATION_SHOWMORE_TEXT_RO = {
    showMoreLabel: 'Afișează întregul cod',
    showLessLabel: 'Restrânge codul',
};
